import { useNavigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import { useEffect } from "react";

import styles from "./style.module.css";
import iStyles from "./iStyles.module.css";
import { Background4 } from "../../components/Background";
import ActionButton from "../../components/ActionButton";
import HeartImg from '../../../assets/adhd/heart.webp'
import cloud from '../../../assets/adhd/cloud.webp'
import {
  getMobileOperatingSystem,
  hRatio,
  triggerEvent,
  wRatio,
} from "../../constants/utils";
import UserStore from "../../../stores/UserStore";

const Welcome = () => {
  const navigate = useNavigate();
  const isiOS = getMobileOperatingSystem() === "iOS";

  useEffect(() => {
    ReactPixel.pageView();
  }, []);

  const handleActionBtnPress = () => {
    UserStore.refreshUserData()
    navigate("/prctn/questionare");
    triggerEvent("Welcome_Screen_Btn_prctn");
  };

  return (
    <Background4>
      <div style={{marginBlock: "2.85rem"}}>
        <p>
          <img src={require("../../../assets/new_onboarding/Evolve_dark.webp")} 
          alt="" 
          style={{
              height: 80*hRatio
          }}
          />
          <br />
          <img src={require("../../../assets/adhd/Group 1000002576.webp")} 
          alt="" 
          style={{
            marginTop: '2rem',
            height: 380*hRatio,
            paddingTop: '1rem'
          }}/>
        </p>
        <div className={styles.WelcomeContent}>
          <p className={isiOS ? iStyles.AdhdTitle1_ : styles.AdhdTitle1_}>
          From procrastination <br /> to productivity
          </p>
          <p className={isiOS ? iStyles.AdhdTitle2 : styles.AdhdTitle2}>
          Unlock your potential.
          </p>
          <div className={styles.Divider} />
          <p className={isiOS ? iStyles.AdhdTitle3 : styles.AdhdTitle3}>
          Get your personalized routine!
          </p>
          <img src={HeartImg} alt="Evolve Heart" className={styles.HeartWelcome} />
          <img src={cloud} alt="cloud img" className={styles.cloud1} />
          <img src={cloud} alt="cloud img" className={styles.cloud2} />
      </div>
        <ActionButton
          text={"Start now"}
          containerStyle={{
            padding: `0px ${92 * wRatio}px`,
            bottom: 80 * hRatio,
          }}
          onClick={handleActionBtnPress}
        />
      </div>
    </Background4>
  );
};

export default Welcome;
